import React from 'react';

const InfoField = ({ label, value, multiline, icon }) => (
  <div className="p-2.5 bg-gray-800 rounded">
    <p className="text-gray-500 text-[10px] tracking-wider mb-0.5 flex items-center gap-1" style={{ fontFamily: 'Oswald, sans-serif' }}>
      {icon}{label}
    </p>
    <p className={`text-gray-200 text-sm ${multiline ? 'whitespace-pre-wrap' : 'truncate'}`}>{value}</p>
  </div>
);

export default InfoField;
